import { FC } from "react";
import { User } from "../../../domain/models/User";
import UserTableRow from "./UserTableRow";
import AddRowsSVG from "../../../components/shared/svg/AddRowsSVG";
import { UserFields } from "../../../domain/enums/UserFieldsEnum";
import { enumToSelectProps } from "../../../tools/EnumTools";
import { useTranslation } from "react-i18next";

interface UsersTableProps {
    users: User[];
    updateHandler: (user: User) => void;
}

const UsersTable: FC<UsersTableProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="w-[95%] h-[calc(100vh-150px)] ml-auto mr-auto relative overflow-auto bg-light-bg-700 dark:bg-dark-bg-800 rounded-xl shadow-lightTable dark:shadow-darkTable">
            <table className="w-full text-sm text-left text-light-text-100 dark:text-dark-text-100">
                <thead className="sticky top-0 text-[14px] font-extralight leading-[16px] text-light-text-100 dark:text-dark-text-100 bg-light-bg-800 dark:bg-dark-bg-900">
                    <tr className="text-center px-2 py-3 group relative">
                        {Object.values(enumToSelectProps(UserFields, "console.users.table")).map((value) => (
                            <th
                                key={`th-users-table-${value.labelKey}`}
                                className="px-2 py-3 group border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900"
                            >
                                {t(value.labelKey)}
                            </th>
                        ))}
                        {/* <th className="px-2 py-3 border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900">
                            <button
                                className="flex items-center justify-center w-[28px] h-[28px] mx-auto"
                                title="Додати рядок"
                            >
                                <AddRowsSVG className="w-[25px] h-[25px] fill-light-fill-100 dark:fill-dark-fill-100" />
                            </button>
                        </th> */}
                    </tr>
                </thead>
                <tbody>
                    {props.users.map((user) => (
                        <UserTableRow
                            key={`tr-user-table-${user.id}`}
                            user={user}
                            updateHandler={props.updateHandler}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UsersTable;
